<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none">
    <g clip-path="url(#a)" fill-rule="evenodd" clip-rule="evenodd" fill="#0B5CFF">
      <path
        d="M14.38 2.148a2.372 2.372 0 0 0-3.309 0L2.248 10.8a.791.791 0 0 1-1.103 0 .754.754 0 0 1 0-1.082l8.824-8.653a3.954 3.954 0 0 1 5.514 0 3.774 3.774 0 0 1 1.104 3.245 3.942 3.942 0 0 1 3.308 1.082l.046.046a3.772 3.772 0 0 1 0 5.408l-7.98 7.825a.25.25 0 0 0 0 .36L13.6 20.64a.754.754 0 0 1 0 1.081.791.791 0 0 1-1.103 0l-1.639-1.607a1.758 1.758 0 0 1 0-2.524l7.98-7.827a2.264 2.264 0 0 0 0-3.245l-.045-.045a2.372 2.372 0 0 0-3.307-.002l-6.574 6.447-.002.002-.09.09a.791.791 0 0 1-1.103 0 .755.755 0 0 1 0-1.082l6.667-6.539a2.266 2.266 0 0 0-.003-3.242z" />
      <path
        d="M13.278 4.311a.754.754 0 0 0 0-1.082.791.791 0 0 0-1.104 0L5.65 9.63a3.773 3.773 0 0 0 0 5.409 3.955 3.955 0 0 0 5.514 0l6.527-6.4a.754.754 0 0 0 0-1.082.791.791 0 0 0-1.104 0l-6.525 6.4a2.373 2.373 0 0 1-3.31 0 2.265 2.265 0 0 1 0-3.245l6.527-6.4z" />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h22v22H0z" /></clipPath>
    </defs>
  </svg>
</template>
<script setup lang="ts">
defineOptions({
  name: 'mark-product-mcp'
})
</script>
